import React, { useState } from 'react';
import { DesctopIcon, FaceIcon, PasswordIcon } from '../../icons/icons';
import { Button } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CalncelDilalog from '../bricks/CalncelDilalog';
import PhotoFace from './PhotoFace';
import { useTranslation } from 'react-i18next'

type Props = {
    guestReg: boolean;
}
const StepIndividual:React.FC<Props> = ({ guestReg }) => {
    const [openCancel, setOpenCancel] = useState(false);
    const [guestPhotoFace, setGuestPhotoFace] = useState(false);
    const { t } = useTranslation()

    const cencelClickOpen = () => {
        setOpenCancel(true);
    }

    const cencelClickClose = () => {
        setOpenCancel(false);
    }

    return (
        <>
            {!guestPhotoFace ?
                <div className="content stepIndividual">
                    <Button className="cancel" color="primary" onClick={cencelClickOpen}>{t('cancel')}</Button>
                    <div className="title">{t('regSteps')}</div>
                    <div className="icon"><DesctopIcon /></div>
                    <ul className="stepIndividual__ul">
                        <li className="stepIndividual__li">
                            <div className="stepIndividual__icon"><FaceIcon /></div>
                            <div className="stepIndividual__label">{t('facePhoto')}</div>
                        </li>
                        <li className="stepIndividual__li">
                            <div className="stepIndividual__icon"><PasswordIcon /></div>
                            <div className="stepIndividual__label">{t('passportPhoto')}</div>
                        </li>
                    </ul>
                    <div className="btnRow">
                        {guestReg ?
                            <Button 
                                fullWidth 
                                variant="contained" 
                                color="primary" 
                                disableElevation
                                onClick={() => setGuestPhotoFace(true)}>{t('continue')}</Button>
                        :
                            <NavLink to="/photo-face">
                                <Button 
                                    fullWidth 
                                    variant="contained" 
                                    color="primary" 
                                    disableElevation>{t('continue')}</Button>
                            </NavLink>
                        }
                    </div>
                    <CalncelDilalog 
                        openCancel={openCancel}
                        cencelClickClose={cencelClickClose} 
                        backHistory="/" 
                        logout={true} />
                </div>
                : <PhotoFace guestPhotoFace={guestPhotoFace} />
            }
        </> 
    );
}

export default StepIndividual;